export { default as QuoteCard } from './QuoteCard';
